import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'

const Index = () => import(/* webpackChunkName: "stands" */ './Index')
const Details = () => import(/* webpackChunkName: "stands" */ './Details')
const Persons = () => import(/* webpackChunkName: "stands" */ './Persons')
const Form = () => import(/* webpackChunkName: "stands" */ './Form')
const MaterialForm = () => import(/* webpackChunkName: "stands" */ './MaterialForm')

export default [
      {
        path: '/event/:eventUri/stands',
        name: 'stands-index',
        component: Index,
      },

      {
        path: 'stand/add',
        name: 'stands-add',
        component: Form,
        meta: {
          auth: true,
        }
      },
      {
        path: 'stand/:standId/edit',
        name: 'stands-edit',
        component: Form,
        meta: {
          auth: true,
        }
      },
      {
        path: 'stand/:standId/',
        name: 'stands-details',
        component: Details,
      },

      {
        path: 'stand/:standId/material/add',
        name: 'material-add',
        component: MaterialForm,
        meta: {
          auth: true,
        }
      },
      {
        path: 'stand/:standId/material/:materialId/edit',
        name: 'material-edit',
        component: MaterialForm,
        meta: {
          auth: true,
        }
      },

      {
        path: 'stand/:standId/persons',
        name: 'stands-persons',
        component: Persons,
      },
    ]
